import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormTemplate,
  FormSelectAlt,
  FormInputAlt,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";

import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { RecommendInvestment } from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import { toast } from "react-toastify";
import { useGetAllAccountsQuery } from "../../../../api";

function RecommendInvestmentAmount() {
  const dispatch = useDispatch();
  const { GlobalData, editMode, editData } = useSelector(
    (state) => state.companyFund
  );
  const { data: banks } = useGetAllAccountsQuery({
    Search: "bank",
    // ApprovalStatus: 0,
    PageSize: 10000,
    PageNumber: 1,
  });

  console.log({ banks });

  const [selectedAccount, setSelectedAccount] = useState(null);

  // console.log({ selectedAccount });
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const feildArray = useFieldArray({
    control: formMethods.control,
    name: "classSetups",
  });

  const RecommendInvestmentAmount = async (formData) => {
    let fmtData = {
      ftLedgerId: selectedAccount?.id,
      availableBalance: selectedAccount?.closingBal,
      investibleAmount: parseInt(formData?.amount),
      approvalStatus: 1,
    };

    if (fmtData.investibleAmount > fmtData.availableBalance) {
      toast.error(
        "Recommended Amount Cannot exceed " + fmtData.availableBalance
      );
    } else {
      const response = await dispatch(RecommendInvestment(fmtData)).then(
        (response) => {
          console.log({ response });
          if (response.payload.successful === true) {
            reset();
            navigate(-1);
          } else {
            toast.error(response.payload.statusMessage);
          }
        }
      );
    }
  };

  return (
    <RouteLayout title={"Finance"}>
      <PageLayout title={"Recommend an amount for Investment"} hasBack={true}>
        <FormProvider {...formMethods} {...feildArray}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(RecommendInvestmentAmount)}
          >
            <section className={DashboardStyle.form_section}>
              <h4 className={`text-[#29382A] mt-5 text-[14px] font-[500]`}>
                Enter the required details
              </h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormSelectAlt
                    title={"Bank"}
                    camelCase={"bankID"}
                    placeholder={"Select Bank"}
                    isOptional={false}
                    array={banks?.result?.map((item, i) => (
                      <option
                        selected={
                          editMode &&
                          editData?.accountNumber === item.accountNumber
                        }
                        key={i}
                        value={item.id} // Using item.id as the value now
                      >
                        {`${item.accountName}`}
                      </option>
                    ))}
                    moreRegister={{
                      onChange: (e) => {
                        let { value } = e.target;
                        let findValue = banks?.result?.find(
                          (item) => item.id === parseInt(value)
                        ); // Find by id
                        console.log({ findValue });
                        setSelectedAccount(findValue);
                        return null;
                      },
                    }}
                  />

                  <FormInputAlt
                    title={"Avaliable Balance"}
                    camelCase={"balance"}
                    placeholder={FormatCurrency(0)}
                    isOptional={true}
                    value={selectedAccount?.closingBal}
                    disabled={true}
                  />
                </div>
                <div className="">
                  <FormInputAlt
                    title={"Amount"}
                    camelCase={"amount"}
                    placeholder={"Enter amount"}
                    isOptional={false}
                  />
                </div>
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => {
                  reset();
                  navigate(-1);
                }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>
              <ActionButtons
                // isLoading={isLoading}
                // disabled={!isValid}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Submit
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

export default RecommendInvestmentAmount;
